const IncomeModel = ({ count = 0, ranges = [] }) => ({
  count: Number(count),
  ranges: JSON.parse(JSON.stringify(ranges)),
});

const PriceModel = ({ count = 0, percentCheaperThanProperty = 0, property = 0, ranges = [] }) => ({
  count: Number(count),
  percentCheaperThanProperty: Number(percentCheaperThanProperty),
  property: Number(property),
  ranges: JSON.parse(JSON.stringify(ranges)),
});

const AudienceAnalytics = ({ income = {}, price = {} }) => ({
  income: IncomeModel(income),
  price: PriceModel(price),
});

export default AudienceAnalytics;

export type AudienceAnalyticsProps = ReturnType<typeof AudienceAnalytics>;
